import React, { useCallback, useState } from 'react'
import useShowHide from '../../utils/useShowHide.ts'

export const useAsyncInputValidation = (
    ref?: React.RefObject<HTMLInputElement>,
    validate?: (value?: string) => Promise<string | number> | null | undefined
) => {
    const loading = useShowHide(false)
    const [networkError, setNetworkError] = useState(false)
    const [validationMessage, setValidationMessage] = React.useState('')
    const handler = useCallback(async (value: string) => {
        if (!validate) return
        loading.open()
        setNetworkError(false)
        try {
            const validationMessage = await validate(value)
            setValidationMessage(validationMessage?.toString() ?? '')
        } catch (e) {
            setNetworkError(true)
        } finally {
            loading.close()
        }
    }, [])

    if (!ref?.current || !validate) return {}

    return {
        validating: loading.visible,
        networkError,
        validate: handler,
        validationMessage
    }
}
